export type VariantKey = "v1" | "v2" | "v3" | "v4" | "v5" | "v6" | "v7" | "v8" | "v9";

export type Palette = { gradStart: string; gradEnd: string; accent: string };

export const palettes: Record<VariantKey, { light: Palette; dark: Palette }> = {
  v1: {
    light: { gradStart: "hsl(35 95% 60%)", gradEnd: "hsl(15 85% 55%)", accent: "hsl(40 100% 70%)" },
    dark:  { gradStart: "hsl(35 80% 35%)", gradEnd: "hsl(15 75% 28%)", accent: "hsl(40 95% 60%)" },
  },
  v2: {
    light: { gradStart: "hsl(265 75% 58%)", gradEnd: "hsl(310 70% 55%)", accent: "hsl(290 90% 75%)" },
    dark:  { gradStart: "hsl(265 60% 32%)", gradEnd: "hsl(310 55% 30%)", accent: "hsl(290 80% 65%)" },
  },
  v3: {
    light: { gradStart: "hsl(190 85% 55%)", gradEnd: "hsl(235 75% 55%)", accent: "hsl(200 95% 70%)" },
    dark:  { gradStart: "hsl(190 65% 28%)", gradEnd: "hsl(235 55% 30%)", accent: "hsl(200 85% 60%)" },
  },
  v4: {
    light: { gradStart: "hsl(155 70% 48%)", gradEnd: "hsl(85 75% 55%)", accent: "hsl(120 80% 65%)" },
    dark:  { gradStart: "hsl(155 55% 25%)", gradEnd: "hsl(85 55% 28%)", accent: "hsl(120 70% 55%)" },
  },
  v5: {
    light: { gradStart: "hsl(345 80% 60%)", gradEnd: "hsl(20 90% 58%)", accent: "hsl(5 95% 70%)" },
    dark:  { gradStart: "hsl(345 60% 32%)", gradEnd: "hsl(20 65% 32%)", accent: "hsl(5 80% 60%)" },
  },
  v6: {
    light: { gradStart: "hsl(180 65% 45%)", gradEnd: "hsl(45 90% 55%)", accent: "hsl(50 95% 65%)" },
    dark:  { gradStart: "hsl(180 50% 24%)", gradEnd: "hsl(45 65% 32%)", accent: "hsl(50 85% 60%)" },
  },
  v7: {
    light: { gradStart: "hsl(205 85% 60%)", gradEnd: "hsl(280 60% 58%)", accent: "hsl(240 80% 75%)" },
    dark:  { gradStart: "hsl(205 60% 30%)", gradEnd: "hsl(280 50% 32%)", accent: "hsl(240 70% 65%)" },
  },
  v8: {
    light: { gradStart: "hsl(215 30% 38%)", gradEnd: "hsl(155 70% 42%)", accent: "hsl(160 75% 55%)" },
    dark:  { gradStart: "hsl(215 25% 20%)", gradEnd: "hsl(155 50% 22%)", accent: "hsl(160 65% 50%)" },
  },
  v9: {
    light: { gradStart: "hsl(300 80% 58%)", gradEnd: "hsl(35 95% 58%)", accent: "hsl(320 90% 70%)" },
    dark:  { gradStart: "hsl(300 60% 32%)", gradEnd: "hsl(35 70% 32%)", accent: "hsl(320 80% 60%)" },
  },
};

export const slugToVariant: Record<string, VariantKey> = {
  "zero-investment-launch": "v1",
  "startup-confidence": "v2",
  "ai-validation": "v3",
  "growth-playbook": "v4",
  "pricing-positioning": "v5",
  "fundraising-mena": "v6",
  "hiring-first-team": "v7",
  "legal-ops-africa": "v8",
  "ship-in-30-days": "v9",
};

export function djb2(str: string): number {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
  return h;
}

const ORDER: VariantKey[] = ["v1", "v2", "v3", "v4", "v5", "v6", "v7", "v8", "v9"];

export function resolveVariant(slug: string): VariantKey {
  return slugToVariant[slug] ?? ORDER[djb2(slug) % 9];
}
